import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]
  static values = {
    placement: { type: String, default: "bottom-end" }
  }

  connect() {
    this.boundClose = this.close.bind(this)
  }

  disconnect() {
    this.removeClickOutsideListener()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    // Close other open menus
    document.querySelectorAll('[data-context-menu-target="menu"]:not(.hidden)').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.classList.add('hidden')
      }
    })

    this.menuTarget.classList.remove('hidden')
    
    // Position menu
    this.positionMenu()
    
    // Add click outside listener
    setTimeout(() => {
      document.addEventListener('click', this.boundClose)
    }, 10)
    
    // Focus first item
    this.focusFirstItem()
  }

  close() {
    this.menuTarget.classList.add('hidden')
    this.removeClickOutsideListener()
  }

  removeClickOutsideListener() {
    document.removeEventListener('click', this.boundClose)
  }

  positionMenu() {
    const button = this.buttonTarget
    const menu = this.menuTarget
    const buttonRect = button.getBoundingClientRect()
    
    // Reset positioning
    menu.style.top = ''
    menu.style.bottom = ''
    menu.style.left = ''
    menu.style.right = ''
    
    // Position based on placement value
    const placement = this.placementValue
    
    if (placement.includes('bottom')) {
      menu.style.top = '100%'
      menu.style.marginTop = '0.25rem'
    } else if (placement.includes('top')) {
      menu.style.bottom = '100%'
      menu.style.marginBottom = '0.25rem'
    }
    
    if (placement.includes('end')) {
      menu.style.right = '0'
    } else if (placement.includes('start')) {
      menu.style.left = '0'
    }
  }

  focusFirstItem() {
    const firstItem = this.menuTarget.querySelector('a, button')
    if (firstItem) {
      firstItem.focus()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
      this.buttonTarget.focus()
    } else if (event.key === 'ArrowDown') {
      event.preventDefault()
      this.focusNextItem()
    } else if (event.key === 'ArrowUp') {
      event.preventDefault()
      this.focusPreviousItem()
    }
  }

  focusNextItem() {
    const items = Array.from(this.menuTarget.querySelectorAll('a:not([disabled]), button:not([disabled])'))
    const currentIndex = items.indexOf(document.activeElement)
    const nextIndex = currentIndex + 1 < items.length ? currentIndex + 1 : 0
    items[nextIndex]?.focus()
  }

  focusPreviousItem() {
    const items = Array.from(this.menuTarget.querySelectorAll('a:not([disabled]), button:not([disabled])'))
    const currentIndex = items.indexOf(document.activeElement)
    const previousIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : items.length - 1
    items[previousIndex]?.focus()
  }
}

